<script>
import axios from 'axios';
export default {
    methods: {
        validateStep3() {
            const data = this.SelectedData;
            const errors = [];
            if(!data.verificationCode) {
                errors.push('Verification Code');
            }

            if(errors.length) {
                this.errors = errors;
                return false;
            } else {
                this.errors = false;
            }
            return true;
        },
        checkTwilioCode() {
            const formData = new FormData();
            formData.append('verificationCode', this.SelectedData.verificationCode);
            formData.append('transactionId', this.SelectedData.transactionId);
            formData.append('holidayNow', this.holidayNow);
            return axios
                .post(this.siteUrl + 'include/API/checkTwilioCode.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data.status == 'expired code') {
                        const errors = [];
                        errors.push('Verification code has been expired!');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'max attempts') {
                        const errors = [];
                        errors.push('Maximum 5 attemts are allowed!');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'not valid') {
                        const errors = [];
                        errors.push('Verification code is not valid!');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'already ordered') {
                        const errors = [];
                        errors.push('Free samples are only allowed for new customers. Only one free sample is allowed per customer and/or household.');
                        this.errors = errors;
                        window.scrollTo(0, 0);
                        return false;
                    } else if(response.data.status == 'pending') {
                        this.SelectedData.finalStatus = 'pending';
                        return true;
                    } else if(response.data.status == 'success') {
                        this.SelectedData.finalStatus = 'success';
                        return true;
                    }
                    
                });
        },
    }
}
</script>